import { Matrix } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { AbstractInteractorTool } from './tools';
import { RoomElementInteractors } from "./interactors";
import { EditRoomElement } from './../cmd/EditRoomElement';
import { getRotationQuaternion } from '@egr/wcf/modules/core/utils/MeshUtils';
export class ScaleBackgroundImage extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mStartPos = new Vector3(0, 0, 0);
        this.mCommand = null;
        this.mLengthFeedback = null;
    }
    initialize(pMode, pPointIndex, pRoomElement, pPointPosition) {
        this.mMode = pMode;
        this.mRoomElement = pRoomElement;
        this.mCommand = new EditRoomElement(this.mRoomManager, this.mRoomElement);
        this.mPointIndex = pPointIndex;
        //this.mCirlceSnapping = new CirlceSnapping(this.mRoomManager);
        this.mInitialPointMove = true;
        this.prepareSnapping();
        this.mRoomManager.beginInteraction();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        this.mRoomManager.endInteraction();
        super.stop();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        this.mStartPos = pPos;
    }
    // tslint:disable-next-line:cyclomatic-complexity
    updatePointerPosition(pPos) {
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        this.mStartPos = this.mStartPos;
        let tNodePos = this.mRoomElement.node.position.clone();
        let tpointsCenter1 = new Vector3(0, 0, 0);
        let tpointsCenter2 = new Vector3(0, 0, 0);
        let tpointsCenterDiff = new Vector3(0, 0, 0);
        let tRotation = getRotationQuaternion(this.mRoomElement.node).clone();
        let tM = new Matrix();
        tRotation.toRotationMatrix(tM);
        let tpointsPos = Vector3.TransformCoordinates(pPos, this.mRoomElement.transformInverted);
        let tIP = false;
        let tDist = 0;
        switch (this.mMode) {
            case ScaleBackgroundImage.Mode.MovePoint:
                if (this.mInitialPointMove) {
                    this.mInitialPointMove = false;
                }
                switch (this.mPointIndex) {
                    case 0:
                        tPoints[0].x = tpointsPos.x;
                        tPoints[1].x = tpointsPos.x;
                        tDist = Vector3.Distance(tPoints[0], tPoints[3]);
                        tPoints[0].z = tPoints[1].z + (tDist / this.mRoomElement.ratioWH);
                        tPoints[3].z = tPoints[1].z + (tDist / this.mRoomElement.ratioWH);
                        break;
                    case 1:
                        tPoints[1].z = tpointsPos.z;
                        tPoints[2].z = tpointsPos.z;
                        tDist = Vector3.Distance(tPoints[0], tPoints[1]);
                        tPoints[0].x = tPoints[2].x - (tDist * this.mRoomElement.ratioWH);
                        tPoints[1].x = tPoints[2].x - (tDist * this.mRoomElement.ratioWH);
                        break;
                    case 2:
                        tPoints[1].z = tpointsPos.z;
                        tPoints[2].z = tpointsPos.z;
                        tDist = Vector3.Distance(tPoints[0], tPoints[1]);
                        tPoints[2].x = tPoints[1].x + (tDist * this.mRoomElement.ratioWH);
                        tPoints[3].x = tPoints[1].x + (tDist * this.mRoomElement.ratioWH);
                        break;
                    case 3:
                        tPoints[3].x = tpointsPos.x;
                        tPoints[2].x = tpointsPos.x;
                        tDist = Vector3.Distance(tPoints[0], tPoints[3]);
                        tPoints[0].z = tPoints[2].z + (tDist / this.mRoomElement.ratioWH);
                        tPoints[3].z = tPoints[2].z + (tDist / this.mRoomElement.ratioWH);
                        break;
                    default:
                        break;
                }
                tIP = this.mRoomElement.imageProportional;
                this.mRoomElement.setImageProportional(true);
                tpointsCenter1 = Vector3.TransformCoordinates(Vector3.Center(tPoints[1], tPoints[2]), tM);
                tPoints = this.centerPoints(tPoints);
                tpointsCenter2 = Vector3.TransformCoordinates(Vector3.Center(tPoints[1], tPoints[2]), tM);
                tpointsCenterDiff = tpointsCenter2.subtract(tpointsCenter1);
                tREgeo.setPoints(tPoints);
                this.mRoomElement.setPosition(tNodePos.subtract(tpointsCenterDiff));
                this.mRoomElement.updateGeometry();
                this.mRoomElement.setImageProportional(tIP);
                break;
            case ScaleBackgroundImage.Mode.ScaleBackgroundImage:
                if (this.mInitialPointMove) {
                    this.mInitialPointMove = false;
                }
                switch (this.mPointIndex) {
                    case -1:
                        tPoints[0].x = tpointsPos.x;
                        tPoints[1].x = tpointsPos.x;
                        break;
                    case -2:
                        tPoints[1].z = tpointsPos.z;
                        tPoints[2].z = tpointsPos.z;
                        break;
                    case -3:
                        tPoints[2].x = tpointsPos.x;
                        tPoints[3].x = tpointsPos.x;
                        break;
                    case -4:
                        tPoints[0].z = tpointsPos.z;
                        tPoints[3].z = tpointsPos.z;
                        break;
                    default:
                        break;
                }
                tIP = this.mRoomElement.imageProportional;
                this.mRoomElement.setImageProportional(false);
                tpointsCenter1 = Vector3.TransformCoordinates(Vector3.Center(tPoints[1], tPoints[2]), tM);
                tPoints = this.centerPoints(tPoints);
                tpointsCenter2 = Vector3.TransformCoordinates(Vector3.Center(tPoints[1], tPoints[2]), tM);
                tpointsCenterDiff = tpointsCenter2.subtract(tpointsCenter1);
                tREgeo.setPoints(tPoints);
                this.mRoomElement.setPosition(tNodePos.subtract(tpointsCenterDiff));
                this.mRoomElement.updateGeometry();
                this.mRoomElement.setImageProportional(tIP);
                break;
            default:
                break;
        }
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    finish() {
        //this.mRectangle._validateConnections(2);
        this.mInitialPointMove = true;
        if (this.mCommand != null) {
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mCommand = null;
                this.stop();
            });
        }
    }
    /*
    protected prepareSnapping(): void
    {
        super.prepareSnapping();
        if (this.mMode !== MoveCirlce.Mode.MoveCirlce) {
            this.mCirlceSnapping.prepareSnapping(this.mCirlce, this.mMode === MoveCirlce.Mode.MoveStart ?
                mdl.CirlceEnding.End : mdl.CirlceEnding.Start);
        }
    }
    */
    prepareFeedback() {
        super.prepareFeedback();
        this.mLengthFeedback = new RoomElementInteractors(this.mRoomManager, this.mRoomElement);
        this.mLengthFeedback.showInteractors(false);
    }
    updateFeedback() {
        super.updateFeedback();
        if (this.mLengthFeedback != null)
            this.mLengthFeedback.showInteractors(false);
    }
    clearFeedback() {
        super.clearFeedback();
        if (this.mLengthFeedback != null) {
            this.mLengthFeedback.clear();
            this.mLengthFeedback = null;
        }
    }
    /*
    private performSnapping(pPos: Vector3): Vector3
    {
        return (this.mCirlceSnapping.snap(pPos, this.mView));
    }
    */
    centerPoints(pPoints) {
        let tRes = new Array();
        let tDistX = (Vector3.Distance(pPoints[0], pPoints[3])) * 0.5;
        let tDistY = (Vector3.Distance(pPoints[0], pPoints[1]));
        let tP1 = pPoints[0];
        tP1.x = -tDistX;
        tP1.z = tDistY;
        tRes.push(tP1);
        let tP2 = pPoints[1];
        tP2.x = -tDistX;
        tP2.z = 0;
        tRes.push(tP2);
        let tP3 = pPoints[2];
        tP3.x = tDistX;
        tP3.z = 0;
        tRes.push(tP3);
        let tP4 = pPoints[3];
        tP4.x = tDistX;
        tP4.z = tDistY;
        tRes.push(tP4);
        return (tRes);
    }
}
//add nested types
(function (ScaleBackgroundImage) {
    let Mode;
    (function (Mode) {
        Mode[Mode["MovePoint"] = 0] = "MovePoint";
        Mode[Mode["ScaleBackgroundImage"] = 1] = "ScaleBackgroundImage";
    })(Mode = ScaleBackgroundImage.Mode || (ScaleBackgroundImage.Mode = {}));
})(ScaleBackgroundImage || (ScaleBackgroundImage = {}));
